import {ModuleController} from "../../../../infrastructure/controllers/module-controller";
import {BaseManagedService} from "../../../../infrastructure/domain-services/base-managed-service";
import {LiveStreamingModuleConfig} from "./live-streaming-module.config";
import {LiveStreamingModuleStore} from "./live-streaming-module.store";
import {LiveStreamingModuleHandlers} from "./handlers/live-streaming-module.handlers";

export class LiveStreamingModuleController extends ModuleController {
  static injectables = [...BaseManagedService.injectables, LiveStreamingModuleConfig, LiveStreamingModuleStore, LiveStreamingModuleHandlers];

}
